import React from "react";
import { useState, useEffect, forwardRef, useImperativeHandle } from "react";
import ReactDOM from 'react-dom';

import {
    ActivityIndicator,
    Image,
    Platform,
    StyleSheet,
    Text,
    View,
    TouchableOpacity,
    SafeAreaView,
    Dimensions,
    Keyboard,
    ScrollView
} from 'react-native';
import { ScreenActivitySheet, ScreenPDFViewer, ScreenSubscription, ScreenSuperRoom } from "../../../shared/utils/Constants";
import AppTheme from "../../../shared/utils/Theme";
import SuperRoom from "../../../shared/components/Rooms/SuperRoom";
import ActionSheet from "../../../shared/components/ActionSheets/ActionSheet";
import ActivitySheet from "../../../shared/components/Activities/ActivitySheet";
import PDFViewer from "../PDF/PDFViewer";
import Subscription from "../../../shared/components/Subscription/Subscription";
import Modal from "../Modal/Modal";

const InViewModal = forwardRef((props: any, ref: any) => {

    const appTheme: AppTheme = new AppTheme();

    const hideTheAlert = () => {
        setAlertContent({
            name: "",
            passProps: {},
            isVisible: false
        });
    }

    const [alertContent, setAlertContent] = useState({
        name: "",
        passProps: {},
        isVisible: false
    });

    // ComponentDidMount
    useEffect(() => {
    }, []);

    useImperativeHandle(ref, () => ({
        showAlert(data: { name: string, passProps?: any }) {
            const { name, passProps = {} } = data;
            setAlertContent({
                name,
                passProps,
                isVisible: true
            });
        },

        hideAlert() {
            hideTheAlert();
        }
    }));

    const getModalComponent = () => {
        if (alertContent.name === ScreenSuperRoom) {
            return <SuperRoom onCloseRequest={hideTheAlert} {...alertContent.passProps} />
        } else if (alertContent.name === ScreenActivitySheet) {
            return <ScrollView style={{ flex: 1, paddingVertical: appTheme.pixelPerfect(20) }}>
                <ActivitySheet inPager={true} onCloseRequest={hideTheAlert} {...alertContent.passProps} />
            </ScrollView>
        } else if (alertContent.name === ScreenPDFViewer) {
            return <PDFViewer closeTheDocument={hideTheAlert} {...alertContent.passProps} />
        } else if (alertContent.name === ScreenSubscription) {
            return <Subscription onCloseRequest={hideTheAlert} {...alertContent.passProps} />
        }
        return <View />;
    }

    const customStyles = {
        content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
        },
    };

    const renderBackground = () => {
        if ((alertContent.passProps.showBg !== undefined) && (alertContent.passProps.showBg === false)) {
            return <View />
        }
        return <View style={{ position: "absolute", backgroundColor: appTheme.darkBlue, width: appTheme.getFullScreenHeight(), height: appTheme.getFullScreenHeight() }} />;
    }

    return <Modal
        visible={alertContent.isVisible}
        style={customStyles}
        animationType="fade">
        <View style={{ width: appTheme.getFullScreenWidth(), height: appTheme.getFullScreenHeight(), alignItems: "center" }}>
            {renderBackground()}
            <View style={{ width: appTheme.getFullScreenWidth(), height: appTheme.getFullScreenHeight(), alignItems: "center" }}>
                {getModalComponent()}
            </View>
        </View>
    </Modal>
});

export default InViewModal;